
<p-accordionTab (selectedChange)="togglePanel($event)">
	<ng-template pTemplate="header">
		<div class="grid flex align-items-center w-full -mb-3">
			<div [class]="!onExtendedMobile() ? 'col-10' : 'col-12 flex justify-content-center'" class="py-0">
				<span class="font-semibold white-space-nowrap">{{ 'NEW_SAFETY_INPUTS' | translate }}</span>
			</div>
			<div [class]="!onExtendedMobile() ? 'col-2 flex align-items-center justify-content-end' : 'col-12 flex align-items-center justify-content-center'"
							class="py-0">
				<p-button *ngIf="!offline" pTooltip="{{ 'RELOAD' | translate }}"
					tooltipPosition="bottom" icon="pi cm-reload" size="large"
					(click)="$event.stopPropagation(); loadInputs()" [rounded]="false" [text]="true" severity="primary">
				</p-button>
			</div>
		</div>
	</ng-template>
	<div>
		<div *ngIf="loading && !offline">
			<div class="flex align-items-center justify-content-center w-full">
				<p-progressSpinner ariaLabel="loading"></p-progressSpinner>
			</div>
		</div>
		<div class="grid" *ngIf="offline">
			<div class="col-12 flex align-items-center justify-content-center bg-yellow-200 p-1 border-round-xl">
				 <p-tag icon="pi cm-alert" [value]="(unavailableAlertKey() | translate)" severity="warning"></p-tag>
			</div>
		</div>
		<div *ngIf="!loading" class="flex align-items-start justify-content-around" [class]="!onExtendedMobile() ? 'flex-row' : 'flex-column'">
			<div *ngFor="let category of categories" [class]="!onExtendedMobile() ? 'w-9rem' : 'w-full'">
				<div class="flex flex-column">
					<div class="font-semibold mt-2 mb-3">{{ getCategory(category.Category) | uppercase }}</div>
					<div *ngFor="let input of category.SafetyInputs" class="flex flex-row align-items-center justify-content-between">
						<div>{{ input.Name }}</div>
						<p-tag [styleClass]="getInputIcon(input)"></p-tag>
					</div>
				</div>
			</div>
		</div>
	</div>
</p-accordionTab>